module.exports = __webpack_public_path__ + "media/images/pokerroom/lotos/logo-small-aa327311ec4936d9302d40b0f3bf9f3d.png";